var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('company-field-list',{attrs:{"showDetail":true,"list":_vm.fieldList},on:{"select":_vm.handleSelectField}}),_c('company-company-list',{attrs:{"title":"담당 부서(업체) 정보","detailTitle":"부서(업체) 세부 정보","list":_vm.companyList}}),_c('company-user-auth-module',{attrs:{"title":"참여 인원 정보","users":_vm.users,"type":"info","is-email":false,"colData":[
      { head: '구분', key: 'company_id' },
      { head: '사용자명', key: 'name' },
      { head: '연락처', key: 'phone' },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }